export default __webpack_public_path__ + "static/media/2499.cd44cb40.png";